/* global Turbolinks */
Turbolinks.start()

import 'default'
